import { css, variant } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'
import styled, { useTheme } from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { WriskTheme } from '../../themes'

export type LogoProperty = 'default' | 'inverted'

export interface LogoProps {
  variant?: LogoProperty
  className?: string
  id?: string
}

export const LogoImage: FunctionComponent<LogoProps> = ({
  className,
  id,
  variant,
}: LogoProps) => {
  const theme = useTheme() as WriskTheme

  const logo = theme.logo[variant ?? 'default']

  if (!logo) throw new Error(`Logo variant doesn't exist for ${variant}`)

  return (
    <img id={id} className={className} src={logo as string} alt='home' data-test='logo' />
  )
}

const defaultProps = withDefaultProps<LogoProps>({
  variant: 'default',
})

export const Logo = styled(LogoImage).attrs(defaultProps)(
  css({
    fontSize: 0,
  }),
  variant({
    scale: 'Logo',
    prop: 'variant',
    variants: {
      default: {
        display: 'block',
        height: '1.5rem',
      },
    },
  }),
)
